import { jsx as _jsx } from "react/jsx-runtime";
import { ApolloProvider } from "@apollo/client";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import client from "./apollo/apollo";
import App from "../modules/app";
const Root = () => (_jsx(ApolloProvider, Object.assign({ client: client }, { children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) })));
export default Root;
